import Image from 'components/Image';
import NFHSNetworkPlayoffs from 'images/icons/NFHSN_Fall25PlayoffLogo_500w.png';
import styles from './styles/NFHSPlayoffs.module.scss';

export default function NFHSPlayoffs() {
  return <Image className={styles.NFHSPlayoffsLogo} src={NFHSNetworkPlayoffs} />;
}
